"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagedConfigurationType = void 0;
/**
 * The type of the `ManagedConfiguration`.
 *
 * We distinguish between different types in order to apply different business logic to the creation
 * of a configuration.
 */
var ManagedConfigurationType;
(function (ManagedConfigurationType) {
    /**
     * An IQuote configuration is created by an igus sales-person and therefor allows more
     * flexibility. It considers that articles can be invented (not necessarily need an id and a
     * LocalizedArtNr). It also allows supports different configuraiton flows like ECB (starting with
     * Kette) and RCB (starting with Leitung)
     */
    ManagedConfigurationType["IQuote"] = "IQuote";
    /**
     * An Expert configuration can be created by anonymous. It does not allow to invent articles and
     * it only has 1 flow where Leitungen are added first.
     */
    ManagedConfigurationType["Expert"] = "Expert";
    /**
     * An IaConfigurator configuration can be created by anonymous. It does not allow to invent articles
     */
    ManagedConfigurationType["IaConfigurator"] = "IaConfigurator";
    /**
     * A Chainflex Finder configuration can be created by anonymous. It does not allow to invent articles
     */
    ManagedConfigurationType["ChainflexFinder"] = "ChainflexFinder";
})(ManagedConfigurationType = exports.ManagedConfigurationType || (exports.ManagedConfigurationType = {}));
//# sourceMappingURL=ManagedConfigurationType.js.map